import {
  GET_LABREQUESTDELIVERYRESULTPARTIAL_FAIL,
  GET_LABREQUESTDELIVERYRESULTPARTIAL_SUCCESS,
  GET_LABREQUESTDELIVERYRESULTPARTIALS_FAIL,
  GET_LABREQUESTDELIVERYRESULTPARTIALS_SUCCESS,
  ADD_LABREQUESTDELIVERYRESULTPARTIAL_SUCCESS,
  ADD_LABREQUESTDELIVERYRESULTPARTIAL_FAIL,
  UPDATE_LABREQUESTDELIVERYRESULTPARTIAL_SUCCESS,
  UPDATE_LABREQUESTDELIVERYRESULTPARTIAL_FAIL,
  DELETE_LABREQUESTDELIVERYRESULTPARTIAL_SUCCESS,
  DELETE_LABREQUESTDELIVERYRESULTPARTIAL_FAIL,  
  SET_STATE_LABREQUESTDELIVERYRESULTPARTIAL
} from "./actionTypes";

const INIT_STATE = {
  labRequestDeliveryResultPartials: [],
  labRequestDeliveryResultPartial: {},
  error: {},
  loading: false,
  total: 0,
  currentPage: 0,
};

const labRequestDeliveryResultPartials = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LABREQUESTDELIVERYRESULTPARTIALS_SUCCESS:
      return {
        ...state,
        labRequestDeliveryResultPartials: action.payload.labRequestDeliveryResultPartials,
        total: action.payload.total,
        currentPage: action.payload.currentPage,
      };

    case SET_STATE_LABREQUESTDELIVERYRESULTPARTIAL:
      return { ...state, loading: action.payload }

    case GET_LABREQUESTDELIVERYRESULTPARTIALS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_LABREQUESTDELIVERYRESULTPARTIAL_SUCCESS:
      return {
        ...state,
        labRequestDeliveryResultPartials: [...state.labRequestDeliveryResultPartials, action.payload],
      };

    case ADD_LABREQUESTDELIVERYRESULTPARTIAL_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_LABREQUESTDELIVERYRESULTPARTIAL_SUCCESS:
      return {
        ...state,
        labRequestDeliveryResultPartials: state.labRequestDeliveryResultPartials.map(labRequestDeliveryResultPartial =>
          labRequestDeliveryResultPartial.id?.toString() === action.payload.id?.toString()
            ? { ...action.payload, labRequestDeliveryResultPartial }
            : labRequestDeliveryResultPartial
        ),
      };

    case UPDATE_LABREQUESTDELIVERYRESULTPARTIAL_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_LABREQUESTDELIVERYRESULTPARTIAL_SUCCESS:
      return {
        ...state,
        labRequestDeliveryResultPartials: state.labRequestDeliveryResultPartials.filter(
          labRequestDeliveryResultPartial => labRequestDeliveryResultPartial.id.toString() !== action.id.toString()
        ),
      };

    case DELETE_LABREQUESTDELIVERYRESULTPARTIAL_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_LABREQUESTDELIVERYRESULTPARTIAL_SUCCESS:
      return {
        ...state,
        labRequestDeliveryResultPartial: action.payload,
      };

    case GET_LABREQUESTDELIVERYRESULTPARTIAL_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default labRequestDeliveryResultPartials;
